import { Formik } from "formik";
import { FC, createContext } from "react";
import TableService from "./components/TableService";

export interface ServicePageContextProps {}

interface IProps {}

const initialContext = {};

export const ServicePageContext =
  createContext<ServicePageContextProps>(initialContext);

export const ServicePage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <ServicePageContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <TableService />
            </div>
          </div>
        </div>
      </ServicePageContext.Provider>
    </Formik>
  );
};

export default ServicePage;
